import React from 'react';

interface SparrowMarkProps {
  /** Rendered height/width in px. */
  size?: number;
  /** Fill color for the mark. */
  color?: string;
}

/**
 * The SurveySparrow bird mark. To swap in a different brand asset, replace
 * the SVG paths below (keep the viewBox) — LogoFull and LogoIcon both
 * consume this component.
 */
export const SparrowMark = ({ size = 32, color = '#35D0C5' }: SparrowMarkProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 101 100"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path
      fill={color}
      d="M83.3975 25.57C83.8723 18.879 79.9716 12.6555 73.7773 10.2231C67.583 7.78333 60.5341 9.69714 56.3851 14.9345L53.4121 13.9046L50.3807 12.955L47.3127 12.093C51.5056 4.88341 59.0659 0.33264 67.3493 0.0185416C75.6327 -0.288252 83.5217 3.69276 88.2331 10.5737L97.6853 11.2384L83.3975 25.57Z"
    />
    <path
      fill={color}
      d="M90.3661 51.0779L90.3004 53.1451L90.1543 55.2123L89.9205 57.2576L89.5991 59.2809L89.1901 61.3043L88.7007 63.3058L88.1236 65.2853L87.4589 67.243L86.7138 69.1568L85.903 71.0487L84.9826 72.8748L84.0038 74.701L82.9593 76.4687L81.827 78.1706L80.6291 79.8507L79.3508 81.465L78.0287 83.0136L76.6189 84.5183L75.1433 85.9573L73.6313 87.3379L72.0535 88.6308L70.41 89.8799L68.7226 91.0413L66.9914 92.137L65.2018 93.1451L63.3902 94.0947L61.5349 94.9566L59.6357 95.7309L57.7146 96.4175L55.7715 97.0384L53.7847 97.5571L51.7978 98.0099L49.7672 98.3533L47.7584 98.6308L45.7131 98.8061L43.6678 98.9157H41.6371L39.5918 98.828L37.5466 98.6527L35.5159 98.3971L33.5071 98.0538L31.4983 97.6228L29.5334 97.1042L27.5685 96.5198L26.334 97.2064L25.0338 97.8127L23.7336 98.3752L22.3895 98.85L21.0235 99.2371L19.6357 99.5366L18.2259 99.7703L16.8161 99.9237L15.3844 99.9895L13.9527 99.9676L12.5429 99.8799L11.1331 99.6827L9.72333 99.427L24.6247 84.4672C39.3508 92.3708 57.4589 89.6754 69.2924 77.8127C81.1185 65.95 83.9016 47.6958 76.1514 32.8017L83.3829 25.5483L84.4129 27.3452L85.3552 29.1714L86.2317 31.0194L87.0206 32.9332L87.7219 34.869L88.3647 36.8266L88.8979 38.8061L89.3654 40.8076L89.7306 42.8529L90.0082 44.8982L90.22 46.9435L90.3296 48.9887L90.3515 51.056L90.3661 51.0779Z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.5502 81.319C59.3508 81.319 72.9812 67.5791 72.9812 50.6251C72.9812 49.5805 72.93 48.5433 72.8278 47.5206C72.4991 44.2116 71.6444 41.0487 70.3515 38.1342L43.9965 64.4308L28.0506 48.4848C26.6189 47.0531 26.6189 44.7302 28.0506 43.2985C29.4823 41.8668 31.8051 41.8668 33.2368 43.2985L44.0038 54.0655L66.4728 31.6477C63.0104 27.2138 58.3646 23.766 53.0177 21.7865C52.9885 21.7719 52.9665 21.7646 52.9373 21.7573C52.5283 21.6112 52.1119 21.4651 51.6882 21.3263C51.659 21.319 51.6371 21.3117 51.6079 21.3044C41.6225 17.9589 30.9359 16.1473 19.8402 16.1473C16.2098 16.1473 12.6305 16.3446 9.10241 16.7244C7.78759 20.4644 7.07904 24.4819 7.07904 28.6747C7.07904 35.5338 8.98554 41.9326 12.2945 47.3818C12.1777 48.4483 12.1265 49.5294 12.1265 50.6251C12.1265 67.5791 25.7569 81.319 42.5575 81.319H42.5502Z"
    />
  </svg>
);
